(() => {
  const initECPRCarbonCeramic = (root) => {
    if (!root || root.dataset.ecprCcbInitialized === 'true') return;
    root.dataset.ecprCcbInitialized = 'true';

    const finishInputs = root.querySelectorAll('input[name="contact[Caliper finish]"]');
    const padInputs = root.querySelectorAll('input[name="contact[Brake pad option]"]');
    const installInputs = root.querySelectorAll('input[name="contact[Installation method]"]');
    const addOn = root.querySelector('[data-pad-addon]');
    const addOnOptions = root.querySelector('[data-pad-addon-options]');
    const addOnChoices = root.querySelectorAll('[data-pad-addon-choice]');
    const customPaint = root.querySelector('[data-custom-paint-field]');
    const customPaintInput = customPaint ? customPaint.querySelector('input') : null;
    const finishSummary = root.querySelector('[data-summary-finish]');
    const padSummary = root.querySelector('[data-summary-pad]');
    const installSummary = root.querySelector('[data-summary-install]');
    const addOnSummary = root.querySelector('[data-summary-addon]');
    const mobileCta = root.querySelector('.ecpr-ccb__mobile-cta');
    const finalSection = root.querySelector('.ecpr-ccb__final');
    const storageKey = `ecpr-carbon-config-${root.id}`;

    const selectedValue = (inputs) => {
      const selected = Array.from(inputs).find((input) => input.checked);
      return selected ? selected.value : '';
    };

    const updateSummary = () => {
      const finish = selectedValue(finishInputs);
      const pad = selectedValue(padInputs);
      const install = selectedValue(installInputs);
      const addOnEnabled = Boolean(addOn && addOn.checked);

      if (addOnOptions) addOnOptions.hidden = !addOnEnabled;
      if (addOn) addOn.setAttribute('aria-expanded', String(addOnEnabled));
      Array.from(addOnChoices).forEach((input) => {
        input.disabled = !addOnEnabled;
        input.required = addOnEnabled;
      });
      if (addOnEnabled && !selectedValue(addOnChoices) && addOnChoices.length) {
        addOnChoices[0].checked = true;
      }
      const addOnPad = selectedValue(addOnChoices);

      if (finishSummary) finishSummary.textContent = finish;
      if (padSummary) padSummary.textContent = pad;
      if (installSummary) installSummary.textContent = install;
      if (addOnSummary) {
        addOnSummary.textContent = addOnEnabled
          ? addOnPad
          : addOnSummary.dataset.empty;
      }

      if (customPaint) {
        const isCustom = finish === 'Custom Paint Match';
        customPaint.hidden = !isCustom;
        if (customPaintInput) {
          customPaintInput.required = isCustom;
          customPaintInput.disabled = !isCustom;
          if (!isCustom) customPaintInput.value = '';
        }
      }

      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          finish,
          pad,
          install,
          addOn: addOnEnabled,
          addOnPad,
          customPaint: customPaintInput && !customPaintInput.disabled ? customPaintInput.value : ''
        }));
      } catch (error) {
        /* Configuration remains functional if storage is unavailable. */
      }
    };

    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved) {
        [finishInputs, padInputs, installInputs].forEach((inputs, index) => {
          const value = [saved.finish, saved.pad, saved.install][index];
          const inputList = Array.from(inputs);
          if (inputList.some((input) => input.value === value)) {
            inputList.forEach((input) => { input.checked = input.value === value; });
          }
        });
        if (addOn) addOn.checked = Boolean(saved.addOn);
        if (saved.addOnPad) {
          const addOnChoiceList = Array.from(addOnChoices);
          if (addOnChoiceList.some((input) => input.value === saved.addOnPad)) {
            addOnChoiceList.forEach((input) => { input.checked = input.value === saved.addOnPad; });
          }
        }
        if (customPaintInput && saved.customPaint) customPaintInput.value = saved.customPaint;
      }
    } catch (error) {
      /* Ignore malformed or unavailable session storage. */
    }

    root.addEventListener('change', updateSummary);
    if (customPaintInput) customPaintInput.addEventListener('input', updateSummary);

    if (mobileCta && finalSection && 'IntersectionObserver' in window) {
      const finalObserver = new IntersectionObserver((entries) => {
        mobileCta.classList.toggle('is-hidden', entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.08 });
      finalObserver.observe(finalSection);
    }

    updateSummary();
  };

  document.querySelectorAll('[data-ecpr-ccb]').forEach(initECPRCarbonCeramic);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches && event.target.matches('[data-ecpr-ccb]')) {
      initECPRCarbonCeramic(event.target);
    } else {
      event.target.querySelectorAll('[data-ecpr-ccb]').forEach(initECPRCarbonCeramic);
    }
  });
})();
